// imports
import Accordion from 'minsky-kit/js/components/Accordion';

// private statics

// class definition
export default class FAQAccordion extends Accordion {
    // constructor
    constructor (args = {}, objectName = 'Accordion') {
        args.debug = args.debug || false;

        args.group = `group-${Math.random()}`;

        // super
        super(args, objectName);

        this.$trigger = this.$el.querySelector('.accordion__title-wrapper');
        this.$trigger.addEventListener('click', (e) => e.preventDefault());
    }

    open () {
        this.$contentWrapper.style.display = 'block';
        super.open();
    }

    close () {
        super.close();

        // wait for transition
        setTimeout(() => {
            this.$contentWrapper.style.display = 'none';
        }, 501);
    }

    // methods
    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
